import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import GoldenBackground from "./components/GoldenBackground";
import Home from "./pages/Home";
import Read from "./pages/Read";
import Guide from "./pages/Guide";
import Provenance from "./pages/Provenance";
import Privacy from "./pages/Privacy";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AppProvider>
      <div className="App">
        <GoldenBackground />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/read" element={<Read />} />
            <Route path="/read/:bookId/:chapter" element={<Read />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/provenance" element={<Provenance />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AppProvider>
  );
}

export default App;
